import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5349763c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth auth--user auth--register" }
const _hoisted_2 = { class: "auth__left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth__top" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "auth__title" }, "Hozzáférés"),
  /*#__PURE__*/_createElementVNode("p", { class: "auth__text" }, " Ahhoz hogy az RTL+ fiókodat az RTL.hu oldalán is használhasd, az alábbi feltételt el kell fogadnod. ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "auth__form-group"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Megismertem és elfogadom az rtl.hu ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "about_blank",
  href: "https://rtl.hu/adatvedelmi-szabalyzat"
}, "adatkezelési tájékoztatóját", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" és az ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "about_blank",
  href: "https://rtl.hu/felhasznalasi-feltetelek"
}, "általános szerződési feltételeit", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_10 = { class: "auth__back" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isSocialDataUpdate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_checkbox, {
              disabled: _ctx.isRtlHuConsentDisabled(),
              modelValue: _ctx.rtlhuConsent,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rtlhuConsent) = $event)),
              "error-msg": _ctx.getFieldErrorValue('RTLHU_Consent')
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _hoisted_9
              ]),
              _: 1
            }, 8, ["disabled", "modelValue", "error-msg"]),
            _createElementVNode("button", {
              class: "auth__button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, "Elfogadom"),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", {
                href: "",
                class: "backButton",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)), ["prevent"]))
              }, " Másik fiókkal lépek be ")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}